/**
 * MQTT Configuration
 *
 * Configuration for MQTT broker connection settings.
 * Uses REACT_APP_ environment variables (Create React App convention).
 */

const getMqttConfig = () => {
  const defaultProtocol = window.location.protocol === 'https:' ? 'wss' : 'ws';
  const defaultUrl = `${defaultProtocol}://localhost:9001`;

  let brokerUrl =
    process.env.REACT_APP_MQTT_BROKER_URL || defaultUrl;

  // If page is loaded over HTTPS, automatically upgrade ws:// to wss://
  if (window.location.protocol === 'https:' && brokerUrl.startsWith('ws://')) {
    brokerUrl = brokerUrl.replace('ws://', 'wss://');

    // EMQX: ws:// uses 8083, wss:// uses 8084
    if (brokerUrl.includes(':8083/')) {
      brokerUrl = brokerUrl.replace(':8083/', ':8084/');
    }
  }

  const url = new URL(brokerUrl);

  const username = process.env.REACT_APP_MQTT_USERNAME || null;
  const password = process.env.REACT_APP_MQTT_PASSWORD || null;

  const normalizedUsername = username && username.trim() ? username.trim() : null;
  const normalizedPassword = password && password.trim() ? password.trim() : null;

  const clientId = `tracking-url-${Date.now()}-${Math.random().toString(16).slice(2, 8)}`;

  const options = {
    clientId,
    clean: true,
    reconnectPeriod: 5000,
    connectTimeout: 30000,
    keepalive: 60,
  };

  if (normalizedUsername && normalizedPassword) {
    options.username = normalizedUsername;
    options.password = normalizedPassword;
  }

  return {
    brokerUrl,
    protocol: url.protocol === 'wss:' ? 'wss' : 'ws',
    host: url.hostname,
    port: url.port ? parseInt(url.port) : (url.protocol === 'wss:' ? 443 : 80),
    path: url.pathname || '/mqtt',
    clientId,
    options,
  };
};

export default getMqttConfig;

